// Tela 6 — Foto dividida + chamada final. Extraído de
// entrevista-sergio-gargantini.html (bloco #s6). Ver DOCS/06-split-cta.md.
import { escapeHtml, formatWithBoldLines } from '../shared/text'
import { LOGO_PRETO_DATA_URI } from '../shared/logo'
import { PLACEHOLDER_IMAGE_DATA_URI } from '../shared/placeholder'
import { cropToImgStyle } from '../shared/crop'
import type { RenderContext, TemplateDefinition } from '../types'

const SPLIT_ASPECT = (1080 * 0.46) / 1350

export const CSS = `
  .tpl-split-cta{flex-direction:row;}
  .tpl-split-cta .split-photo{
    width:46%;
    position:relative;
    overflow:hidden;
    flex:0 0 auto;
  }
  .tpl-split-cta .split-photo img{display:block;}
  .tpl-split-cta .split-text{
    flex:1;
    padding:40px 30px 40px 26px;
    display:flex;
    flex-direction:column;
  }
  .tpl-split-cta .logo-inline{height:20px; flex:0 0 auto;}
  .tpl-split-cta .logo-inline img{height:100%;}
  .tpl-split-cta .text-block{
    flex:1;
    display:flex;
    flex-direction:column;
    justify-content:center;
  }
  .tpl-split-cta .title-stack{
    position:relative;
    height:232px;
    flex:0 0 auto;
  }
  .tpl-split-cta .watermark6{
    position:absolute;
    top:0;
    left:0;
    z-index:0;
    font-family:'Anton',sans-serif;
    font-size:min(var(--template-vw-11-8, 11.8vw),72px);
    color:var(--ghost);
    line-height:1;
    letter-spacing:-.01em;
    white-space:nowrap;
  }
  .tpl-split-cta .headline6{
    position:absolute;
    top:36px;
    left:0;
    z-index:1;
    height:196px;
    display:flex;
    align-items:flex-start;
    font-family:'Anton',sans-serif;
    font-size:min(var(--template-vw-11-3, 11.3vw),68px);
    line-height:.88;
    letter-spacing:-.01em;
  }
  .tpl-split-cta .headline6-text{
    display:block;
    transform:scaleY(1.5);
    transform-origin:top left;
  }
  .tpl-split-cta .cta{
    margin-top:9%;
    font-family:'Big Shoulders',sans-serif;
    font-weight:200;
    font-size:clamp(19px,var(--template-vw-4-4, 4.4vw),28px);
    line-height:1.18;
  }
  .tpl-split-cta .cta b{font-weight:600;}
`

function render(content: Record<string, unknown>, ctx: RenderContext = {}): string {
  const watermark = escapeHtml(String(content.watermark ?? 'ENTREVISTA'))
  const line1 = escapeHtml(String(content.headlineLine1 ?? ''))
  const line2 = escapeHtml(String(content.headlineLine2 ?? ''))
  const cta = formatWithBoldLines(String(content.cta ?? ''))
  const imgStyle = cropToImgStyle(ctx.imageCrop, SPLIT_ASPECT)
  const src = ctx.imageUrl || PLACEHOLDER_IMAGE_DATA_URI

  return `<section class="slide tpl-split-cta">
    <div class="split-photo reveal-wipe img-reveal">
      <img src="${src}" alt="" style="${imgStyle}">
    </div>
    <div class="split-text">
      <div class="logo-inline reveal r1"><img src="${LOGO_PRETO_DATA_URI}" alt="Lorena"></div>
      <div class="text-block">
        <div class="title-stack">
          <div class="watermark6 reveal r2">${watermark}</div>
          <h2 class="headline6 reveal r3"><span class="headline6-text">${line1}<br>${line2}</span></h2>
        </div>
        <p class="cta reveal r4">${cta}</p>
      </div>
    </div>
  </section>`
}

export const splitCtaTemplate: TemplateDefinition = {
  id: 'split-cta',
  label: 'Foto dividida + CTA',
  tags: ['homem', 'encerramento', 'foto'],
  css: CSS,
  fieldsSchema: [
    { key: 'watermark', label: 'Selo', type: 'text', defaultValue: 'ENTREVISTA' },
    { key: 'headlineLine1', label: 'Nome (linha 1)', type: 'text', placeholder: 'NOME DE' },
    { key: 'headlineLine2', label: 'Sobrenome (linha 2)', type: 'text', placeholder: 'EXEMPLO' },
    {
      key: 'cta',
      label: 'Chamada final',
      type: 'textarea',
      help: 'Use **texto** para deixar um trecho em negrito.',
      placeholder: 'Confira a entrevista completa, **logo a baixo**',
    },
    { key: 'image', label: 'Foto (coluna estreita)', type: 'image', aspectRatio: SPLIT_ASPECT },
  ],
  render,
  previewContent: {
    watermark: 'ENTREVISTA',
    headlineLine1: 'TÍTULO DE',
    headlineLine2: 'EXEMPLO',
    cta: 'Confira a entrevista completa, **logo a baixo**',
  },
  previewCtx: { imageUrl: PLACEHOLDER_IMAGE_DATA_URI },
}
